module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product8-33d32bc9c2a98d871f104c3b4bf0a298.jpg";